import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PolicyStreamCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
}));
